<template>
    <BreadCrumb PageTitle="Prévisualiser une composition" />
    <PreviewComposition />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PreviewComposition from "@/components/Composition/PreviewComposition.vue";
  
    export default defineComponent({
      name: "PreviewCompositionPage",
      components: {
        BreadCrumb,
        PreviewComposition,
      },
    });
  </script>